import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { AuthState } from "./api-types.js";

const STORAGE_KEY = "dosia-admin-auth";

/** 原始持久化 atom — 直接读 localStorage。**测试外不直接消费。** */
export const rawAuthAtom = atomWithStorage<AuthState | null>(
  STORAGE_KEY,
  null,
);

/**
 * Derived atom：自动过期检测。
 * - null 或 expiresAt <= now → 返 null（视为登出）
 * - 否则返 raw AuthState
 *
 * 注意：本 atom 是 **read-only**。set 由 `loginAtom` / `clearAuthAtom` 接管。
 */
export const authAtom = atom<AuthState | null>((get) => {
  const raw = get(rawAuthAtom);
  if (!raw) return null;
  if (Number.isNaN(new Date(raw.expiresAt).getTime())) return null;
  if (new Date(raw.expiresAt).getTime() <= Date.now()) return null;
  return raw;
});

/** 登录成功后调用 — 写 rawAuthAtom。 */
export const loginAtom = atom(null, (_get, set, next: AuthState) => {
  set(rawAuthAtom, next);
});

/** 登出 / 401 redirect 后调用 — 清 rawAuthAtom。 */
export const clearAuthAtom = atom(null, (_get, set) => {
  set(rawAuthAtom, null);
});
